export const shouldDisplay = (({ hiddenPromos, hideConditionalPromoDescription, data }) => {
  const { description, experienceTag, subExperienceTag } = data?.product?.pricing?.promotion || {};
  const shortDesc = description?.shortDesc;
  const hidePromotion = hiddenPromos.find((hiddenPromo) => {
    if (experienceTag === 'BOGO') {
      return hiddenPromo === subExperienceTag;
    }
    return hiddenPromo === experienceTag;
  });
  return !!(data && !hideConditionalPromoDescription && shortDesc && !hidePromotion);
});
